var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.267,25.333L18.134,13.2C19.334,10.133 18.667,6.533 16.134,4C13.467,1.333 9.467,0.8 6.267,2.266L12,8L8,12L2.134,6.266C0.534,9.466 1.2,13.466 3.867,16.133C6.4,18.666 10,19.333 13.067,18.133L25.2,30.266C25.734,30.8 26.534,30.8 27.067,30.266L30.134,27.2C30.8,26.666 30.8,25.733 30.267,25.333Z",
    fill: "#E2897E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/tool.41595a856674f56bde997fe7b7e061ba.svg";
export { ForwardRef as ReactComponent };